export enum Tabs {
    NewCustomer = 1,
    NewJobSite = 2,
    CustomerSearch = 3,
    BillingDetail = 4,
    JobSiteDetail = 5,
    ServiceAgreement = 6,
    ServiceAgreementDetail = 7,
    NewServiceAgreement = 8,
    ServiceAgreementEdit = 9,
    Visit = 10,
    VisitCustomerContact = 11,
    CustomerSearchLte = 12,
    FsLiteNewCustomer = 13,
    FsLiteCustomerViewDetail = 14,
    FsLiteSettingDashboard = 15,
    FsLiteTradeList = 16,
    FsLiteProducts = 17,
    FsLiteWorkOrderList = 18,
    FsLiteWorkOrderCreate = 19,
    FsLiteWorkOrderView = 20,
    FsLitePriceBookList = 21,
    FsLiteMaterialItemCreate = 22,
    FsLiteWorkOrderEdit = 23,
    FsLiteLaborItemCreate = 24,
    FsLiteLaborItemDetail = 25,
    FsLiteMaterialItemDetail = 26,
    FsLiteServiceItemForm = 27,
    FsLiteServiceItemView = 28,
    FsLiteLaborItemEdit = 29,
    FsLiteMaterialItemEdit = 30,
    FsLiteServiceItemEdit = 31,
    FsLiteAccountingLog = 32,
    FsLiteWorkOrderReviewEdit = 33,
    FsLiteWorkOrderReview = 34,
    FsLiteWorkOrderReviewView = 35,
    Dashboard = 36,
    FsLiteCustomerJobSiteEdit = 37,
    FsLiteImportData = 38,
    FsLiteWorkOrderDispatcher = 39,
    CustomerLandingPage = 40,
    FsLiteReportsDashboard = 41,
    FsLiteServiceAgreementItem = 42,
    FsLiteServiceAgreementItemDetail = 44,
    FsLiteServiceAgreementEdit = 45,
    NewEstimate = 46,
    EstimateEdit = 47,
    EstimateDetail = 48,
    EstimateList = 49
}
